import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BASE_MODULES } from 'src/app/constants/shared-imports';
import { CommonService } from 'src/Services/common.service';

@Component({
  standalone: true,
  selector: 'app-ab-chatbot-landing-page',
  templateUrl: './ab-chatbot-landing-page.component.html',
  styleUrls: ['./ab-chatbot-landing-page.component.scss'],
  imports:[...BASE_MODULES]
})
export class AbChatbotLandingPageComponent implements OnInit{
  selectedValue: string = "";
  userLoggedIn: string ="";
  @Output() storeSelectedValue = new EventEmitter<string>()
  constructor(private commonService: CommonService,  private translate: TranslateService){

  }
ngOnInit(){
  this.userLoggedIn = this.commonService.userLoggedIn;
}
  selectOption(value: string) {
    switch (value) {
      case 'Trend':
        this.selectedValue = this.translate.instant('ct.global.msg.chat-trend');
        break;
      case 'Find':
        this.selectedValue = this.translate.instant('ct.global.msg.chat-assistance');
        break;
      case 'Check':
        this.selectedValue = this.translate.instant('ct.global.msg.chat-landing-text1');
        break;
      case 'Reset':
        this.selectedValue = this.translate.instant('ct.global.msg.chat-resetPassword');
        break;
    }
    this.commonService.changeisGptcalled(true);
    this.storeSelectedValue.emit(this.selectedValue);

  }
}
